import React, { useContext } from 'react';
import { EditorContext } from '../EditorContext';
import { Group } from '../types';
import { orderBy } from 'lodash';

interface SubjectsListProps {
  subjects: {
    id: string;
    slug: string;
    name: string;
  }[];
  group?: Group;
}

const SubjectsList: React.FC<SubjectsListProps> = ({ subjects, group }) => {
  const { state, dispatch } = useContext(EditorContext);
  const alphaSubjects = orderBy(subjects, subject => subject.name);

  return (
    <ul className="list pa0 ma0">
      {alphaSubjects.map(subject => (
        <li
          key={subject.id}
          data-testid={`select-subject-${subject.slug}-${group ? group.slug : 'subject-trackers'}`}
          className="w-50 dib ph1"
        >
          <button
            className={`${
              state.input.subjectIds.includes(subject.id)
                ? 'light-tan hover-light-tan bg-near-white'
                : 'navy hover-blue'
            } f6 pa3 pointer ba b--light-gray br2 mb2 db w-100`}
            onClick={() => {
              dispatch({
                type: 'addSubject',
                subjectId: subject.id,
                groupId: group ? group.id : 'subject-trackers'
              });
            }}
          >
            {subject.name}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default SubjectsList;
